export const partners = [
  {
    imageSrc: "/assets/images/partners/1.png",
    name: "Direct Reach Ethiopia",
    link: "https://www.dre.org.au/",
  },
  {
    imageSrc: "/assets/images/partners/2.png",
    name: "GCF Global",
    link: "https://gcfglobal.org/en/#",
  },
  {
    imageSrc: "/assets/images/partners/3.png",
    name: "Ethiopia Social Accountability Program",
    link: "https://www.vng-esap.org/",
  },
  {
    imageSrc: "/assets/images/partners/4.png",
    name: "Civil Society Support Programme Ethiopia",
    link: "https://www.intrac.org/projects/establishing-civil-society-support-programme/",
  },
  {
    imageSrc: "/assets/images/partners/5.png",
    name: "Ministry of Women and Society Affairs",
    link: "https://www.mowsa.gov.et/",
  },
  {
    imageSrc: "/assets/images/partners/6.png",
    name: "The World Bank",
    link: "https://www.worldbank.org/",
  },
  {
    imageSrc: "/assets/images/partners/7.png",
    name: "USAID",
    link: "https://www.usaid.gov/",
  },
  {
    imageSrc: "/assets/images/partners/8.png",
    name: "Plan International",
    link: "https://plan-international.org/",
  },
  {
    imageSrc: "/assets/images/partners/9.png",
    name: "unicef",
    link: "https://www.unicef.org/",
  },
  {
    imageSrc: "/assets/images/partners/10.png",
    name: "Partners in the Horn of Africa",
    link: "http://www.partnersinthehorn.org/http://www.partnersinthehorn.org/",
  },
];
